import './table-grid.css';
export default {
  "button": "pf-v6-c-button",
  "modifiers": {
    "grid": "pf-m-grid",
    "animateExpand": "pf-m-animate-expand",
    "expanded": "pf-m-expanded",
    "expandable": "pf-m-expandable",
    "selected": "pf-m-selected",
    "compact": "pf-m-compact",
    "action": "pf-m-action",
    "noPadding": "pf-m-no-padding",
    "hoverable": "pf-m-hoverable",
    "nowrap": "pf-m-nowrap",
    "fitContent": "pf-m-fit-content",
    "truncate": "pf-m-truncate",
    "gridMd": "pf-m-grid-md",
    "gridLg": "pf-m-grid-lg",
    "gridXl": "pf-m-grid-xl",
    "grid_2xl": "pf-m-grid-2xl"
  },
  "table": "pf-v6-c-table",
  "tableAction": "pf-v6-c-table__action",
  "tableButton": "pf-v6-c-table__button",
  "tableCheck": "pf-v6-c-table__check",
  "tableCompoundExpansionToggle": "pf-v6-c-table__compound-expansion-toggle",
  "tableExpandableRow": "pf-v6-c-table__expandable-row",
  "tableExpandableRowContent": "pf-v6-c-table__expandable-row-content",
  "tableFavorite": "pf-v6-c-table__favorite",
  "tableIcon": "pf-v6-c-table__icon",
  "tableInlineEditAction": "pf-v6-c-table__inline-edit-action",
  "tableTbody": "pf-v6-c-table__tbody",
  "tableTd": "pf-v6-c-table__td",
  "tableText": "pf-v6-c-table__text",
  "tableTh": "pf-v6-c-table__th",
  "tableThead": "pf-v6-c-table__thead",
  "tableToggle": "pf-v6-c-table__toggle",
  "tableToggleIcon": "pf-v6-c-table__toggle-icon",
  "tableTr": "pf-v6-c-table__tr"
};